import './Teams.css'
import RingLoader from "react-spinners/RingLoader";
import React, { useEffect, useState } from 'react'

export default function Teams() {

    const [isLoading, setIsLoading] = useState(false)

    useEffect(() => {
        setIsLoading(true)
        setTimeout(() => {
            setIsLoading(false)
        }, 3000);
    }, [])

    return (
        <div className="teams-page">
            {isLoading ?
                <div className="loading" >
                    <RingLoader color={'#34CEE6'} loading={isLoading} size={150} />
                </div>
                :
                <div className="container">
                    <div className="cover-all-games">
                        <div className="item Motion">
                            <p className="title">Motion</p>
                            <ul>
                                <li>Cienema</li>
                                <li>TVC</li>
                                <li>Viral</li>
                                <li>Show</li>
                                <li>Drama</li>
                            </ul>
                        </div>
                        <div className="item Design">
                            <p className="title">Design</p>
                            <ul>
                                <li>Brnad Design</li>
                                <li>Motion Design</li>
                                <li>Social Design</li>
                            </ul>
                        </div>
                        <div className="item Sound">
                            <p className="title">Sound</p>
                            <ul>
                                <li>Ken Music</li>
                                <li>Producing Music</li>
                                <li>Music Studio</li>
                            </ul>
                        </div>
                        <div className="item Academy">
                            <p className="title">Academy</p>
                            <ul>
                                <li>Ken Music Academy</li>
                                <li>Academic Seminar</li>
                            </ul>
                        </div>
                        <div className="item Games">
                            <p className="title">Games</p>
                            <ul>
                                <li>MiniGame</li>
                                <li>Vitual R&D</li>
                            </ul>
                        </div>
                        <div className="item Platform">
                            <p className="title">Platform</p>
                            <ul>
                                <li>Video Monster</li>
                                <li>IMG Monster</li>
                                <li>Monster Trend</li>
                            </ul>
                        </div>
                        <div className="item Development">
                            <p className="title">Development</p>
                            <ul>
                                <li>Severless</li>
                                <li>Platform</li>
                            </ul>
                        </div>
                        <div className="item Store">
                            <p className="title">Store</p>
                            <ul>
                                <li>Space</li>
                                <li>Maho Table</li>
                            </ul>
                        </div>
                    </div>
                </div>
            }
        </div>
    )
}
